import { BlobServiceClient } from '@azure/storage-blob';

export const isStorageConfigured = (sasToken, storageAccountName) => {
    return (!storageAccountName || !sasToken) ? false : true;
};

const _getBlobServiceClient = (accountUrl, sasToken, serviceClient = BlobServiceClient) => {
    const blobService = new serviceClient(
        `${accountUrl}/?${sasToken}`
    );

    return blobService;
};

const _createBlobInContainer = async (containerClient, file, filePath) => {
    try {
        const blobClient = containerClient.getBlockBlobClient(filePath);

        const options = {
            blobHTTPHeaders: {
                blobContentType: file.type
            }
        };
    
        await blobClient.uploadBrowserData(file, options);
    
        return blobClient.url;
    } catch (err) {
        console.error(`Error creating blob: ${err.message}`);

        return 'Blob was not created';
    }
};

export const uploadFileToBlob = async (storageAccountName, containerName, sasToken, filePath, file = null) => {
    if (!file) return {
        blobUrl: ''
    };

    const accountUrl = `https://${storageAccountName}.blob.core.windows.net`;

    const blobService = _getBlobServiceClient(accountUrl, sasToken);
    const containerClient = blobService.getContainerClient(containerName);

    const url = await _createBlobInContainer(containerClient, file, filePath);

    if (url === 'Blob was not created') {
        return {
            blobUrl: null
        };
    } else {
        // Is building the url necessary? Use the one that's returned instead?
        const blobUrl = `${accountUrl}/${containerName}/${filePath}`;

        return { blobUrl };
    }
};
